import { createFileRoute } from '@tanstack/react-router';
import Home from '@/pages/Home';

export const Route = createFileRoute('/')({
  component: Home,
  /**
   * `?move=<id>` — the next-move card's deep link (T11 D11). A notification or an email lands
   * here and the card scrolls itself into view. An id that does not match the current move
   * does nothing at all.
   *
   * `?src=push` — and only that one value — says the link came from the PUSH notification, which
   * is what the seen beacon reports as `push` (22 Sep 2026). The bell row and the Inbox link to
   * the same move WITHOUT it, so they are ordinary `home` sightings. Anything else in `src` is
   * dropped: it is an analytics marker, not a routing input, and the card reads one value.
   *
   * The return type is annotated on purpose (Codex C9): inferred, every existing `Link to="/"`
   * in the app would have to start passing a `search` prop.
   */
  validateSearch: (search: Record<string, unknown>): { move?: string; src?: 'push' } => ({
    ...(typeof search.move === 'string' && search.move.length > 0 ? { move: search.move } : {}),
    ...(search.src === 'push' ? { src: 'push' as const } : {}),
  }),
});
